export type UpdateEnvironmentCopyRequestRequest = {
  envrnmntCopyDplymntReqSeqNum: number;
  updateDateTime: string;
};
